import BuildPortfolio from "./BuildPortfolio.jsx";

export default BuildPortfolio;



// WEBPACK FOOTER //
// ./src/components/pages/Create_portfolio_by_Advisor/build_portfolio/index.js